/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getVerificationMethodTypeDecoder,
  getVerificationMethodTypeEncoder,
  getVerificationRelationshipDecoder,
  getVerificationRelationshipEncoder,
  type VerificationMethodType,
  type VerificationMethodTypeArgs,
  type VerificationRelationship,
  type VerificationRelationshipArgs,
} from ".";

/**
 * Verification method for DID document
 *
 * Represents a cryptographic key that can be used to verify
 * signatures or perform other cryptographic operations
 */
export type VerificationMethod = {
  /** Method identifier (e.g., "key-1") */
  id: string;
  /** Type of verification method */
  methodType: VerificationMethodType;
  /** DID of the controller (usually the DID itself) */
  controller: string;
  /** Public key in multibase format (base58btc) */
  publicKeyMultibase: string;
  /** Verification relationships this key has */
  relationships: Array<VerificationRelationship>;
  /** Creation timestamp */
  createdAt: bigint;
  /** Revoked flag */
  revoked: boolean;
};

export type VerificationMethodArgs = {
  /** Method identifier (e.g., "key-1") */
  id: string;
  /** Type of verification method */
  methodType: VerificationMethodTypeArgs;
  /** DID of the controller (usually the DID itself) */
  controller: string;
  /** Public key in multibase format (base58btc) */
  publicKeyMultibase: string;
  /** Verification relationships this key has */
  relationships: Array<VerificationRelationshipArgs>;
  /** Creation timestamp */
  createdAt: number | bigint;
  /** Revoked flag */
  revoked: boolean;
};

export function getVerificationMethodEncoder(): Encoder<VerificationMethodArgs> {
  return getStructEncoder([
    ["id", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["methodType", getVerificationMethodTypeEncoder()],
    ["controller", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    [
      "publicKeyMultibase",
      addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
    ],
    ["relationships", getArrayEncoder(getVerificationRelationshipEncoder())],
    ["createdAt", getI64Encoder()],
    ["revoked", getBooleanEncoder()],
  ]);
}

export function getVerificationMethodDecoder(): Decoder<VerificationMethod> {
  return getStructDecoder([
    ["id", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["methodType", getVerificationMethodTypeDecoder()],
    ["controller", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    [
      "publicKeyMultibase",
      addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder()),
    ],
    ["relationships", getArrayDecoder(getVerificationRelationshipDecoder())],
    ["createdAt", getI64Decoder()],
    ["revoked", getBooleanDecoder()],
  ]);
}

export function getVerificationMethodCodec(): Codec<
  VerificationMethodArgs,
  VerificationMethod
> {
  return combineCodec(
    getVerificationMethodEncoder(),
    getVerificationMethodDecoder(),
  );
}
